import {GlobalFonts} from 'fonts/globalFonts';
import logo from 'img/logo.svg';
import outdatedImg from 'img/illustration-homepage.svg';
import React, {useEffect, useRef} from 'react';
import {useTranslation} from "react-i18next";
import 'v4/pages/front/OutdatedFront/OutdatedFrontPage.scss';

export default function OutdatedFrontPage() {
    const {t} = useTranslation();
    const reloadRef = useRef(null);

    useEffect(() => reloadRef.current?.focus(), []);

    return (
        <main className={`loginpage bg-env-${process.env.REACT_APP_ENV}`}>
            <GlobalFonts/>

            <span className="round"/>
            <span className="round"/>
            <span className="round"/>

            <div className="row row-fluid justify-content-between login">
                <div className="col-12 col-lg-7 col-xl-8 login__images">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-auto">
                            <img src={logo} className="login__images__logo" alt="POL CRM"/>
                        </div>
                        <div className="col-auto">
                            <p className="login__images__text">{t('pol_slogan')}</p>
                        </div>
                    </div>

                    <div className="login__images__presentation flex-fill d-none d-md-block">
                        <img src={outdatedImg} alt=""/>
                    </div>
                </div>

                <div className="col-12 col-lg-5 col-xl-4 login__form">
                    <div className="row login__form__content">
                        <div className="col-12 col-sm-8 align-self-center"
                             role="alertdialog"
                             aria-labelledby="outdated-front-message">
                            <p className="login__form__title" id="outdated-front-message">
                                {t('outdated_front_title')}
                            </p>
                            <p className="login__form__text mb-3">
                                {t('outdated_front_message')}
                            </p>
                            <button type="button"
                                    ref={reloadRef}
                                    className="btn login__form__btn outdated-front__action"
                                    onClick={() => window.location.reload()}>
                                {t('reload_now', 'Recharger')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
